<template>
  <div>
 
    <Button
        :size="15"
        color="#fd7e14"
        colorText="#ffffff"
        tooltip="Filtrar contenido"
        icon="fas fa-filter"
        round
        :width="30"
        @click.native="openModal('modal')"
        traslate
    />

    <ui-modal ref="modal" title="Filtros para planificación anual" size="large" @close="ActionSetZindexModal(false)">
      <!-- Fila 1 -->

      <div>
          <!-- Row 1 -->
          <div class="d-flex">
            <ui-select
              class="w-50 mr-3"
              has-search
              label="Años"
              placeholder="Seleccionar"
              v-model="anioModel"
              :options="yearsFilter"
              :keys="{ value: 'id', label: 'name' }"
            />

            <ui-select
              class="w-50"
              has-search
              label="Cliente"
              placeholder="Seleccionar"
              v-model="clienteModel"
              :options="clienstFilter"
              :keys="{ value: 'id', label: 'name' }"
            />
          </div>

          <!-- Row 2 -->
          <div class="d-flex">
            <ui-select
              class="w-50 mr-3"
              has-search
              label="Contenedor"
              placeholder="Seleccionar"
              v-model="contenedorModel"
              :options="containersFilter"
              :keys="{ value: 'id', label: 'name' }"
            />

            <ui-select
              class="w-50"
              has-search
              label="Producto"
              placeholder="Seleccionar"
              v-model="productoModel"
              :options="productsFilter"
              :keys="{ value: 'id', label: 'name' }"
            />
          </div>

          <!-- Row 3 -->
          <div class="d-flex">
            <ui-select
              class="w-100 mr-3"
              has-search
              label="Puertos"
              placeholder="Seleccionar"
              v-model="puertosModel"
              :options="portFilter"
              :keys="{ value: 'id', label: 'name' }"
            />
            <ui-select
              class="w-100"
              has-search
              label="Servicio integral"
              placeholder="Seleccionar"
              v-model="servicoIntegralModel"
              :options="servIntegralFilter"
              :keys="{ value: 'id', label: 'name' }"
            />
          </div>

          <ui-select
            class="w-100"
            has-search
            label="Consignatarios"
            placeholder="Seleccionar"
            :options="consigneeFilter"
            v-model="consignatarioModel"
            :keys="{ value: 'id', label: 'name' }"
          />

      </div>

      <!-- Footer -->
      <div class="d-flex justify-content-between w-100 mt-5">
        <div class="d-flex">
          <Button
            text="Cerrar"
            :size="25"
            color="#dc3545"
            colorText="#ffffff"
            :width="130"
            :height="40"
            @click.native="closeModal('modal')"
          />

          <Button
            v-if="isClearBtn"
            inactive
            class="ml-3"
            text="Limpiar filtros"
            :size="25"
            color="#ffa500"
            colorText="#ffffff"
            :width="130"
            :height="40"
          />

          <Button
            v-else
            class="ml-3"
            text="Limpiar filtros"
            :size="25"
            color="#ffa500"
            colorText="#ffffff"
            :width="130"
            :height="40"
            @click.native="limpiarFiltros()"
          />
        </div>

        <Button
          v-if="isFilterBtn"
          text="Filtrar"
          :size="25"
          color="#007bff"
          colorText="#ffffff"
          :width="130"
          :height="40"
          inactive
        />

        <Button
          v-else
          text="Filtrar"
          :size="25"
          color="#007bff"
          colorText="#ffffff"
          :width="130"
          :height="40"
          @click.native="filtrar()"
        />
        
      </div>
    </ui-modal>
  </div>
</template>

<script>

import UiModal from "keen-ui/src/UiModal";
import UiSelect from "keen-ui/src/UiSelect";

import Button from '../../common/Button';
import { mapActions, mapState } from 'vuex';
import { listarConFiltros } from '../../../constants/lineas';

export default {
  components: { Button, UiModal, UiSelect },
  computed : {
    ...mapState('lineas',['yearsFilter','clienstFilter','containersFilter','productsFilter','servIntegralFilter','portFilter','consigneeFilter'])
  },
  data() {
    return {
      anioModel : [],
      clienteModel : [],
      contenedorModel : [],
      productoModel : [],
      servicoIntegralModel : [],
      puertosModel: [],
      consignatarioModel: [],
      isClearBtn: false,
      isFilterBtn: false,
      yearsFilterAux: []
    };
  },
  methods : {

    ...mapActions(['ActionSetZindexModal']),
    ...mapActions('lineas',['actionSetDataFiltradaPlanificacionAnual','actionSetDataPlanificacionAnualTabla']),

    openModal(ref) {
      this.$refs[ref].open();
      this.ActionSetZindexModal(true);
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },

    limpiarFiltros(){

      this.isClearBtn = true;

      this.anioModel = [];
      this.productoModel = [];
      this.clienteModel = [];
      this.consignatarioModel = [];
      this.contenedorModel = [];
      this.contenedorModel = [];
      this.servicoIntegralModel = [];

      this.actionSetDataPlanificacionAnualTabla();
      this.$vToastify.loader('Limpiando filtros');

      setTimeout(() => {
          this.$vToastify.stopLoader();
          this.isClearBtn = false;
          this.$vToastify.success("Filtros quitados", "Proceso finalizado");
      }, 4000);

    },

    async filtrar(){

      this.isFilterBtn = true;
      this.$vToastify.loader('Aplicando filtros');

      let filters = {"filters" : {
        "year": Object.keys(this.anioModel).length ? parseInt(this.anioModel.id) : null ,
        "product_id": Object.keys(this.productoModel).length ? this.productoModel.id : null,
        "client_id": Object.keys(this.clienteModel).length ? this.clienteModel.id : null,
        "consignee_id": Object.keys(this.puertosModel).length ? this.puertosModel.id : null,
        "port_id": Object.keys(this.consignatarioModel).length ? this.consignatarioModel.id : null,
        "container_id": Object.keys(this.contenedorModel).length ? this.contenedorModel.id : null,
        "integral_service_id": Object.keys(this.servicoIntegralModel).length ? this.servicoIntegralModel.id : null
      }};


      let sql = await listarConFiltros(filters);

      if (sql.code == 200) {
        this.actionSetDataFiltradaPlanificacionAnual(sql.data);
        this.isFilterBtn = false;
        this.$vToastify.stopLoader();
        this.$vToastify.success( "Filtro aplicado", "Proceso finalizado");
      }else{

        this.isFilterBtn = false;
        this.$vToastify.error("Error al aplicar filtros", "Proceso finalizado");
        this.$vToastify.stopLoader();

      }

    },

  },

}
</script>

<style>

</style>